import { Store } from "vuex";
import { Category, namespace as siteNamespace, SiteState } from "../modules/site";
import { AppMessage } from "../modules/site";
import { ApplicationPartGet, ApplicationPartPatch, Controllers, ServerErrorResult, settingName } from "@infoland/iprova-api";
import VueI18n from "vue-i18n";
import { RootState } from "..";
import { SnackBarTimeout } from "@/enums";

export class SiteStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the title of this part of the site */
    public get title(): string {
        return this.store.getters[`${siteNamespace}/title`];
    }

    /** Sets the title of this part of the site */
    public set title(title: string) {
        this.store.commit(`${siteNamespace}/title`, title);
    }

    /** Gets the snackBar message */
    public get snackBarMessage(): AppMessage {
        return this.store.getters[`${siteNamespace}/snackBarMessage`];
    }

    public get isDialogDisplayed(): boolean {
        return this.store.getters[`${siteNamespace}/isDialogDisplayed`];
    }

    /** Gets the can go back  */
    public get canGoBack(): boolean {
        return this.store.getters[`${siteNamespace}/canGoBack`];
    }

    /**
     * Sets the global snackbar message
     * @param text the text of the message
     * @param timeout the timeout of the snackbar
     */
    public setSnackBarMessage(text: string | VueI18n.TranslateResult, isError?: boolean, timeout?: SnackBarTimeout): void {
        let message: string;
        if (typeof text === "string") message = text;
        else message = text.toString();

        this.store.dispatch(`${siteNamespace}/setSnackBarMessage`, { text: message, isError, timeout } as AppMessage);
    }

    public setSnackBarMessageLookup(lookupKey: string, isError?: boolean, timeout?: SnackBarTimeout): void {
        this.store.dispatch(`${siteNamespace}/setSnackBarMessage`, { text: lookupKey, languageLookup: true, isError, timeout } as AppMessage);
    }

    public setSnackBarServerErrorMessage(serverError: ServerErrorResult): void {
        this.store.dispatch(`${siteNamespace}/setSnackBarMessage`, {
            text: "general.messages.errorInternalServerError",
            languageLookup: true,
            isError: true,
            lookupData: serverError
        } as AppMessage);
    }

    public get applicationParts(): ApplicationPartGet[] {
        return this.store.getters[`${siteNamespace}/application_parts`];
    }

    public loadApplicationParts(forceRefetch: boolean = false): Promise<ApplicationPartGet[]> {
        return this.store.dispatch(`${siteNamespace}/loadApplicationPart`, forceRefetch);
    }

    public updateFavoriteForApplicationPart(applicationPart: ApplicationPartPatch): void {
        this.store.dispatch(`${siteNamespace}/updateApplicationPartFavorite`, applicationPart);
    }

    public setIsDialogDisplayed(isDialogDisplayed: boolean): void {
        this.store.dispatch(`${siteNamespace}/setIsDialogDisplayed`, isDialogDisplayed);
    }

    public getCategoriesAsync(): Promise<Category[]> {
        return this.store.dispatch(`${siteNamespace}/getCategories`);
    }
    /**Set can go back */
    public setCanGoBack(canGoBack: boolean) {
        this.store.commit(`${siteNamespace}/canGoBack`, canGoBack);
    }
}
